import React from 'react'
import FlashMessageView from './FlashMessageView'

export default class FlashMessage extends React.Component {

    constructor(props) {
        super(props)
        this.flashDismissed = this.flashDismissed.bind(this)
    }

    flashDismissed = () => {
        this.props.dismissFlashMessage()
    }
    
    render() {
        return this.props.flashMessage 
            ? <FlashMessageView 
                flashDismissed={this.flashDismissed} 
                flashMessage={this.props.flashMessage}/> 
            : <div></div>
    }
}


// WEBPACK FOOTER //
// ./src/components/FlashMessage/FlashMessage.jsx